import { render, staticRenderFns } from "./SlotAttend.vue?vue&type=template&id=5877ad90&scoped=true&"
import script from "./SlotAttend.vue?vue&type=script&lang=js&"
export * from "./SlotAttend.vue?vue&type=script&lang=js&"
import style0 from "./SlotAttend.vue?vue&type=style&index=0&id=5877ad90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5877ad90",
  null
  
)

export default component.exports